export enum StorageKey
{
  // Local Storage
  USER              = 'user',
  DOCUMENT          = 'document',
  PRODUCT_IMAGE     = 'product-image',
  KEY_POINTS        = 'keypoints',
  MIXTURES          = 'mixtures',
  PRODUCTS          = 'products',
  PRODUCT_FAMILIES  = 'productFamilies',
  CATEGORIES        = 'categories',
  LANGUAGES         = 'languages',
  SELECTED_LANGUAGE = 'selected-language',
  CHEAT             = 'cheat',
  UNIT              = 'unit',
  CART              = 'cart',
  CONTACTS          = 'contacts',

  // Indexed DB Store
  TRANSLATIONS_STORE = 'translations',
  IMAGES_STORE       = 'images',
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/storage-key.enum.ts